/**
 * Strips the branded PTC signature block(s) the API appends to preview/send email bodies
 * (frontend mirror of api/Services/EmailSignature.StripSignatures, SUP-SIG-03).
 *
 * The compose dialog's draft must stay CLEAN: the backend composes signature + translation at
 * preview/send time from the clean draft, so a draft that already carries a signature would
 * accumulate one more on every Preview click — the 2026-07-20 duplicated-signature bug. Any
 * body coming back from the API is run through this before being stored in editor state.
 *
 * Matches from the "Warm regards," paragraph through the closing tag of the signature's single
 * <table> (lazy, so stacked signatures each match individually).
 */
export function stripSignatureHtml(body: string): string {
  return body.replace(/\s*<p>Warm regards,<\/p>[\s\S]*?<\/table>/gi, '').trimEnd();
}
